export enum SortEnum {
    EXPIRY_DATE_ASC = "expires_at",
    EXPIRY_DATE_DESC = "-expires_at",
    QUALIFICATION_NAME_ASC = "qualification_name",
    QUALIFICATION_NAME_DESC = "-qualification_name",
    EDUCATOR_NAME_ASC = "educator_name",
    EDUCATOR_NAME_DESC = "-educator_name",
    EMPLOYEE_NAME_ASC = "employee_name",
    EMPLOYEE_NAME_DESC = "-employee_name",
}
